import $ from 'expose-loader?exposes=$,jQuery!jquery'
import 'semantic-ui-api/api'
import 'semantic-ui-search/search'
import Select2 from 'select2/src/js/select2/core'
import S2Defaults from 'select2/src/js/select2/defaults'
import S2Utils from 'select2/src/js/select2/utils'
import { parseResponse, uaMatch } from './utils'

const thisMethods = ['open', 'close', 'destroy']

$.extend($.fn, {
  slideToElement: function (target) {
    const $target = $('a[name=' + target + ']')
    if ($target.length) {
      const targetOffset = $target.offset().top
      $('html,body').animate({
        scrollTop: targetOffset - 100
      }, 500, 'linear', () => {})
      return false
    }
  },
  addLoader: function () {
    const elm = this[0],
      offsetParent = elm.offsetParent || document.body,
      totalWidth = this.outerWidth(),
      totalHeight = this.outerHeight()
    let position, anchor, anchor_pos

    if (!this.length) {
      return
    }

    if (
      ['TD', 'TH', 'TABLE'].indexOf(offsetParent.tagName) > -1 &&
      $(offsetParent).css('display').indexOf('table') === -1
    ) {
      //position is invalid when table display is changed
      anchor = this.add(this.parents())
        .filter(function () {
          return $(this).css("position") === "relative" || this.tagName === 'body'
        })
        .eq(0)
      anchor_pos = anchor.offset()
      position = this.offset()

      position.left -= anchor_pos.left
      position.top -= anchor_pos.top
    } else {
      anchor = this
      position = this.position()
    }

    let preloader = $('#preloader')
    if (preloader.length > 0) {
    } else {
      preloader = $('<div id="preloader" class="justify-content-center align-items-center"><div class="loader loader-light"></div></div></div>')
    }

    preloader.css({
      position: 'absolute',
      top: position.top,
      left: position.left,
      width: totalWidth,
      height: totalHeight
    })

    preloader.show()
    preloader.appendTo(anchor)
  },
  TabbedMenu: function (o) {
    const el = o !== undefined && o.elem !== undefined ? o.elem : '.tabb'
    const num = o !== undefined && o.num !== undefined ? o.num : 0
    $(el).hide()
    $(el).eq(num).show()
    $('a.tchoice').eq(num).addClass('picked')

    $(this).find('a.tchoice').each(function (n) {
      $(this).on('click', function () {
        $(el).hide()
        $(el).eq(n).show()
        $('a.tchoice').removeClass('picked')
        $(this).addClass('picked')
        return false
      })
    })
    return ($(this))
  },
  ajaxHint: function () {
    let cansearch = true

    $(this).each(function () {
      $(this).on('keyup', function () {
        if (cansearch) {
          if ($(this).val() !== '' && $(this).val() !== ' ') {
            cansearch = false
            $.post('?cmd=tickets&action=kbhint', {
              query: $(this).val()
            }, function (data) {
              cansearch = true
              const resp = parseResponse(data)
              if (resp !== false && typeof(resp) == 'string' && resp !== '') {
                $('#hintarea').html(resp).slideDown()
              }
            });
          } else {
            $('#hintarea').html('').slideUp('fast')
          }
        }
      })
    })
  },
  select2: function (options) {
    options = options || {}

    if (typeof options === 'object') {
      this.each(function () {
        const instanceOptions = $.extend(true, {}, options),
          instance = new Select2($(this), instanceOptions)
      })

      return this
    } else if (typeof options === 'string') {
      let ret
      const args = Array.prototype.slice.call(arguments, 1)

      this.each(function () {
        const instance = S2Utils.GetData(this, 'select2')

        if (instance == null && window.console && console.error) {
          console.error(
            'The select2(\'' + options + '\') method was called on an ' +
            'element that is not using Select2.'
          )
        }

        ret = instance[options].apply(instance, args)
      })

      // Check if we should be returning `this`
      if (thisMethods.indexOf(options) > -1) {
        return this
      }

      return ret
    } else {
      throw new Error('Invalid arguments for Select2: ' + options)
    }
  },
  uaMatch
})

$.fn.select2.defaults = S2Defaults
